import { Component } from '@angular/core';
import { GungFlowDetailsComponent } from 'gung-standard';

@Component({
    selector: 'cult-flow-details',
    templateUrl: './cult-flow-details.component.html',
    styleUrls: ['./cult-flow-details.component.scss'],
    standalone: false
})
export class CultFlowDetailsComponent extends GungFlowDetailsComponent {}
